import { createSelector } from 'reselect';
import { PaymentState } from './reducer';
import { RootReducer } from '../rootReducer';

export const selectPaymentStore = (state: RootReducer) => state.payment;

export const selectSolidMerchantData = createSelector(
  selectPaymentStore,
  (paymentStore: PaymentState) => paymentStore.solidMerchantData
);

export const selectIsMerchantLoading = createSelector(
  selectPaymentStore,
  (paymentStore: PaymentState) => paymentStore.isMerchantDataLoading
);
